import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

export const InstanceContext = createContext();

export const InstanceProvider = ({ children }) => {
    const [instance, setInstance] = useState([]);

    return (
        <InstanceContext.Provider value={{ instance, setInstance }}>
            {children}
        </InstanceContext.Provider>
    );
};

InstanceProvider.propTypes = {
    children: PropTypes.node.isRequired
};
